import { render, staticRenderFns } from "./ChantierDetailView.vue?vue&type=template&id=65de80c4&scoped=true&"
import script from "./ChantierDetailView.vue?vue&type=script&lang=js&"
export * from "./ChantierDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ChantierDetailView.vue?vue&type=style&index=0&id=65de80c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65de80c4",
  null
  
)

export default component.exports